import { render, staticRenderFns } from "./TelaAvisoEmail.vue?vue&type=template&id=fc022a1a&scoped=true&"
import script from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"
export * from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc022a1a",
  null
  
)

export default component.exports